import React from "react";
import IconNotif from "../../assets/images/icon.png";

function pwpNotification({ firstName, lastName, message }) {
  return (
    <div className="holder-notification flex flex-row">
      <div className="holder-notif-icon">
        <img src={IconNotif} width="24" />
      </div>
      <p className="notification-text font-montserrat">
        {firstName} {lastName}, {message}
      </p>
    </div>
  );
}

export default pwpNotification;
